export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9258.c4284e74.jpg";